export default "__VITE_PUBLIC_ASSET__15636a98__"